exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Toastify__toast{font-family:inherit;border-radius:5px;color:#fff}.Toastify__toast--default{border:1px solid #555;background:#000;color:#fff}.Toastify__toast--error{border:1px solid #555;background:#fff;color:#fff}.Toastify__progress-bar--default{background:#ffc000}.Toastify__close-button{padding-top:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Toasts/toasts.scss
// module id = 818
// module chunks = 0